import { useIntl } from 'react-intl';
import { EmptyState } from '@ets/design-system';

function StorageEmptyState({
  current,
  filters,
}: {
  current: Objekt;
  filters: Request.FilterParams;
}) {
  const intl = useIntl();

  if (current?.type === 'space') {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', flex: 1, alignItems: 'center' }}>
        <EmptyState
          size="l"
          icon="file-lines"
          title={intl.formatMessage({ id: 'storage.browserHeader.spaceEmpty' })}
          description={intl.formatMessage({ id: 'storage.browserHeader.folderEmptySub' })}
          testId="storage-empty-space"
        />
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', flex: 1, alignItems: 'center' }}>
      <EmptyState
        size="l"
        icon="file-lines"
        title={intl.formatMessage({ id: 'storage.browserHeader.folderEmpty' })}
        description={intl.formatMessage({ id: 'storage.browserHeader.folderEmptySub' })}
        testId="storage-empty-folder"
      />
    </div>
  );
}

export default StorageEmptyState;
